var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.226 16.95 13.778 12l4.448-4.95C19.635 5.483 18.514 3 16.4 3H8.454C6.338 3 5.218 5.483 6.626 7.05L11.074 12l-4.448 4.95C5.218 18.517 6.338 21 8.454 21h7.945c2.115 0 3.236-2.483 1.827-4.05",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastIcon);
export default __webpack_public_path__ + "static/media/toastIcon.59a5a2d2d26f98e7eb3130505f61749d.svg";
export { ForwardRef as ReactComponent };